module.exports = __webpack_public_path__ + "img/Waldspaziergang.ff7f2b89.svg";